export const validateObjectPropRequiredFields = (componentName, propValue, options = {}) => {
  const { requiredFields = [] } = options;

  const value = propValue || {};

  // Check for any missing required fields within the object
  const missingFields = requiredFields.filter((field) => !(field in value));
  if (missingFields.length) {
    // Provide specific details on missing fields in addition to generic Vue prop warning
    // eslint-disable-next-line no-console
    console.error(`${componentName}: Missing required fields: ${missingFields.join(', ')}`);
    return false;
  }

  return true;
};
